import type { FC, ReactNode } from 'react'

import { Reveal } from '@/components/motion/reveal'
import { tools } from '@/constants/home'

export const HomeStack: FC = (): ReactNode => {
    return (
        <section
            id='stack'
            className='relative z-[2] flex w-full flex-col items-center gap-12 overflow-clip bg-background px-4 py-section-sm md:gap-16 lg:gap-20 lg:px-6'
        >
            <div className='flex w-full flex-col gap-4 md:flex-row md:items-end md:justify-between md:gap-6'>
                <div className='w-full py-6 pr-6 md:max-w-[60%] md:flex-1'>
                    <h2 className='t-label text-left text-foreground'>
                        Tools I build with
                    </h2>
                </div>

                <p className='t-body max-w-[440px] pb-6 text-left text-muted-foreground md:max-w-[32%]'>
                    The languages, frameworks and platforms I reach for most, from the first prototype to the server it runs on.
                </p>
            </div>

            <ul className='grid w-full grid-cols-2 border-l border-t border-border md:grid-cols-3 lg:grid-cols-4'>
                {tools.map((tool, index) => (
                    <li key={tool.name} className='border-b border-r border-border'>
                        <Reveal delay={(index % 4) * 0.05} y={12} className='h-full'>
                            <div className='flex h-full min-h-[132px] flex-col justify-between gap-6 p-4 text-foreground md:min-h-[160px] lg:p-6'>
                                <span className='t-meta text-left text-umber'>
                                    {tool.group}
                                </span>

                                <span className='t-title text-left'>
                                    {tool.name}
                                </span>
                            </div>
                        </Reveal>
                    </li>
                ))}
            </ul>
        </section>
    )
}
